var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    width: 28,
    height: 28,
    fill: "#615E5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.5C8.75 18.5 9 18.75 9 19V21C9 21.2812 8.75 21.5 8.5 21.5H6.5C6.21875 21.5 6 21.2812 6 21V19C6 18.75 6.21875 18.5 6.5 18.5H8.5ZM8.5 8.5C8.75 8.5 9 8.75 9 9V11C9 11.2812 8.75 11.5 8.5 11.5H6.5C6.21875 11.5 6 11.2812 6 11V9C6 8.75 6.21875 8.5 6.5 8.5H8.5ZM8.5 13.5C8.75 13.5 9 13.75 9 14V16C9 16.2812 8.75 16.5 8.5 16.5H6.5C6.21875 16.5 6 16.2812 6 16V14C6 13.75 6.21875 13.5 6.5 13.5H8.5ZM21.5 19C21.75 19 22 19.25 22 19.5V20.5C22 20.7812 21.75 21 21.5 21H11.5C11.2188 21 11 20.7812 11 20.5V19.5C11 19.25 11.2188 19 11.5 19H21.5ZM21.5 9C21.75 9 22 9.25 22 9.5V10.5C22 10.7812 21.75 11 21.5 11H11.5C11.2188 11 11 10.7812 11 10.5V9.5C11 9.25 11.2188 9 11.5 9H21.5ZM21.5 14C21.75 14 22 14.25 22 14.5V15.5C22 15.7812 21.75 16 21.5 16H11.5C11.2188 16 11 15.7812 11 15.5V14.5C11 14.25 11.2188 14 11.5 14H21.5Z",
    fill: "#07080C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGrey);
export default __webpack_public_path__ + "static/media/listGrey.bac281f3062d036a7351a34efcded710.svg";
export { ForwardRef as ReactComponent };